export default __webpack_public_path__ + "static/media/close_hover.76d76d72.svg";